import type { ReactNode } from 'react';
import type { IconName } from '../Icons';

export type NoteStorage = 'localStorage' | 'sessionStorage';

export interface NoteProps {
  id: string;
  text: ReactNode;
  actions?: ReactNode;
  icon?: IconName;
  closable?: boolean;
  variant?: NoteVariant;
  onDismiss?: () => void;
  storage?: NoteStorage;
}

export enum NoteVariant {
  Default,
  Positive,
  Negative,
  Warning,
  Primary,
  Announcement,
}
